export const url = "https://game-31.herokuapp.com";
// export const url = "http://localhost:4000";
